function Navbar() {
  return (
    <div className=" py-6 px-5 max-w-6xl mx-auto w-full md:py-10">
      <nav>
        <h4 data-aos="fade-down" data-aos-delay="650" className="uppercase font-sans font-bold text-slate text-2xl self-center"><span className="text-sky-darker">paw</span>sitivity</h4>
      </nav>
    </div>
  )
}

export default Navbar